/* ==========================================================================
   TØTE — mobile sliders for T01 USP bar and T03 UGC reviews
   Kopstorm CommV · SplideJS, one per view, fast autoplay.
   USP: arrows + pagination dots. UGC: pagination dots only.
   Both destroyed at 750px and above, where CSS grid takes over.

   Gate aware: on the storefront the test roots ship hidden (kv-tt-gated)
   until Intelligems reveals them. Mounting Splide inside a hidden container
   produces zero width slides, so each slider mounts only once its test root
   is actually visible, observed via ResizeObserver.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__kvSlidersInit) return;
  window.__kvSlidersInit = true;

  var BASE = {
    mediaQuery: 'min',
    type: 'loop',
    perPage: 1,
    gap: '14px',
    arrows: true,
    autoplay: true,
    interval: 2200,
    speed: 450,
    pauseOnHover: true,
    breakpoints: { 750: { destroy: true } }
  };

  function isVisible(el) {
    return el.offsetParent !== null || el.getClientRects().length > 0;
  }

  function mountWhenVisible(el, opts) {
    if (el.__kvSplide || el.__kvSplidePending) return;

    function mount() {
      if (el.__kvSplide) return;
      el.__kvSplide = new Splide(el, opts).mount();
    }

    if (isVisible(el)) {
      mount();
      return;
    }

    el.__kvSplidePending = true;
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        if (isVisible(el)) {
          observer.disconnect();
          el.__kvSplidePending = false;
          mount();
        }
      });
      observer.observe(el);
    } else {
      /* Fallback for very old browsers: mount immediately and let the
         window resize listener inside Splide correct the layout. */
      el.__kvSplidePending = false;
      mount();
    }
  }

  function mountAll() {
    if (typeof Splide === 'undefined') return;

    document.querySelectorAll('[data-kv-usp-slider]').forEach(function (el) {
      mountWhenVisible(el, Object.assign({}, BASE, { pagination: true }));
    });

    document.querySelectorAll('[data-kv-ugc-slider]').forEach(function (el) {
      mountWhenVisible(el, Object.assign({}, BASE, { arrows: false, pagination: true, interval: 2600 }));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})();
